import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/authentication/auth.service';
import { UsuariosService } from 'src/app/services/personas/usuarios.service';
import { InformesRxService } from 'src/app/services/transacciones/informes-rx.service';

interface MenuAppItem {
  title: string;
  description: string;
  avatar: string;
  ruta: string;
  tipo: string;
  acceso: boolean;
}

const MENU_APP_ASESOR_BASE: MenuAppItem[] = [
  { title: 'Ordenes Generadas', description: 'Revisa las ordenes de los doctores', avatar: 'assets/img/nueva-orden.webp', ruta: 'orders', tipo: 'orders', acceso: false },
  { title: 'Estadística', description: 'Consulta el avance de tus visitas', avatar: 'assets/img/estadistica-menu.webp', ruta: 'chart_adviser', tipo: 'chart_adviser', acceso: false },
  { title: 'Maps visitas', description: '9 Visitas', avatar: 'assets/img/ubicacion.webp', ruta: 'maps-doctor', tipo: 'maps-doctor', acceso: false },
  { title: 'Gestión del día', description: 'Calendario de gestión del asesor', avatar: 'assets/img/gestion-dia.webp', ruta: 'calendar', tipo: 'calendar', acceso: false },
  { title: 'Blocks', description: 'Blocks de ordenes', avatar: 'assets/img/block-ordenes.webp', ruta: 'blocks', tipo: 'blocks', acceso: false },
  { title: 'Ordenes físicas', description: 'Gestión de ordenes físicas', avatar: 'assets/img/orden-fisica.webp', ruta: 'gestion-por-tipo', tipo: 'Orden Fisica', acceso: false },
  { title: 'Doctores', description: 'Consulta información de doctores', avatar: 'assets/img/doctores-nueva.webp', ruta: 'credenciales', tipo: 'credenciales', acceso: false },
  { title: 'Consulta criterios', description: 'Gestión de criterios por doctor', avatar: 'assets/img/criterios.webp', ruta: 'criterios', tipo: 'criterios', acceso: false },
  { title: 'Activación', description: 'Gestión del asesor', avatar: 'assets/img/activacion.webp', ruta: 'gestion-por-tipo', tipo: 'Activacion', acceso: false },
  { title: 'Capacitaciones', description: 'Gestión de capacitaciones', avatar: 'assets/img/capacitaciones.webp', ruta: 'gestion-por-tipo', tipo: 'Capacitacion', acceso: false },
  { title: 'Zona', description: 'Gestión de administración', avatar: 'assets/img/zona.webp', ruta: 'gestion-por-tipo', tipo: 'Gestion', acceso: false },
  { title: 'Remisión', description: 'Doctores con remisiones procesadas', avatar: 'assets/img/remisiones.webp', ruta: 'gestion-por-tipo', tipo: 'Remision', acceso: false },
  { title: 'Tomografias 3D', description: 'Envio de tomografias 3D', avatar: 'assets/img/tomografia.webp', ruta: 'tomografia', tipo: 'Tomografia', acceso: false },
  { title: 'Pagos sin efecto', description: 'Pagos sin efecto', avatar: 'assets/img/pago-efecto.webp', ruta: 'gestion-por-tipo', tipo: 'Sin efecto', acceso: false },
  { title: 'Ordenes digitales', description: 'Ordenes pendientes', avatar: 'assets/img/orden-digital.webp', ruta: 'ordenes-pendientes', tipo: 'ordenes-pendientes', acceso: false },
  { title: 'Análisis', description: 'Doctor', avatar: 'assets/img/analisis.webp', ruta: 'remisiones-pagadas', tipo: 'remisiones-pagadas', acceso: false },
  { title: 'Obsequios', description: 'Presentes a doctores', avatar: 'assets/img/obsequio.webp', ruta: 'obsequios', tipo: 'obsequios', acceso: false },
  { title: 'Documentos electrónicos', description: 'Facturación electrónica doctores', avatar: 'assets/img/facturas.webp', ruta: 'gestion-por-tipo', tipo: 'documentos-electronicos', acceso: false },
  { title: 'Doctores(Administrador)', description: 'Doctores administrador', avatar: 'assets/img/doctores-nueva.webp', ruta: 'doctor-administrador', tipo: 'credenciales', acceso: false }
];

interface UsuarioRow {
  id: number;
  nombre: string;
  usuario: string;
  perfil: string;
  profile_id: number | null;
  estado: string;
  ultimo_login: string | null;
  foto: string | null;
  telefonousuario: string | null;
  id_usuario_api: string | null;
  FK_COD_SURCUSU: number | null;
  sucursal: string | null;
  asistente?: string | null;
  personalAC?: string | null;
  ACCESOS_APP_ASE?: string | null;
  omitir_validacion_ip?: string | null;
}

interface ProfileRow {
  id: number;
  name: string;
}

interface SucursalRow {
  COD_SURC: number;
  DIR_SURC: string;
}

@Component({
    selector: 'app-usuarios',
    templateUrl: './usuarios.component.html',
    styleUrls: ['./usuarios.component.scss'],
    standalone: false
})
export class UsuariosComponent implements OnInit {

  public cargando = false;
  public cargandoEdicion = false;
  public guardando = false;

  public usuarios: UsuarioRow[] = [];
  public usuariosFiltrados: UsuarioRow[] = [];
  public profiles: ProfileRow[] = [];
  public sucursales: SucursalRow[] = [];

  public q = '';
  public filtroProfileId = '';
  public filtroEstado = '';
  public currentPage = 1;
  public pageSize = 20;
  public pageSizeOptions = [10, 20, 50, 100];

  public modalAbierto = false;
  public modoEdicion = false;
  private readonly defaultUserPhoto = 'https://cmsalud.ec/usuario-cm.png';

  public form: any = this.getDefaultForm();
  private readonly legacyImageBaseUrl = 'https://sistema.cmsalud.ec/radiografia/';

  public serviciosInforme: { COD_PRO: number; CODN_PRO: string; NOM_PRO: string }[] = [];
  public serviciosSeleccionados: number[] = [];
  public cargandoServiciosInforme = false;

  public seccionInformeAbierta = false;
  public seccionAsesorAbierta = false;

  constructor(
    private usuariosService: UsuariosService,
    private toastr: ToastrService,
    public authService: AuthService,
    private informesRxService: InformesRxService
  ) {}

  ngOnInit(): void {
    this.cargarCatalogosYUsuarios();
  }

  get token(): string {
    return localStorage.getItem('token') || '';
  }

  get totalUsuarios(): number {
    return this.usuarios.length;
  }

  get totalActivos(): number {
    return this.usuarios.filter((u) => String(u.estado) === '1').length;
  }

  get totalInactivos(): number {
    return this.totalUsuarios - this.totalActivos;
  }

  get canRead(): boolean {
    return this.authService.hasPermission('admin.users.read');
  }

  get canWrite(): boolean {
    return this.authService.hasPermission('admin.users.update');
  }

  getDefaultForm() {
    return {
      id: 0,
      nombre: '',
      usuario: '',
      password: '',
      profile_id: '',
      profile_name: '',
      FK_COD_SURCUSU: '',
      telefonousuario: '',
      asistente: '0',
      personalAC: [] as string[],
      accesosAppAse: MENU_APP_ASESOR_BASE.map((item) => ({ ...item })),
      estado: '1',
      omitir_validacion_ip: '0'
    };
  }

  cargarCatalogosYUsuarios() {
    if (!this.canRead) {
      this.toastr.error('No tienes permisos para consultar usuarios');
      return;
    }

    this.cargando = true;

    this.usuariosService.listarProfiles(this.token).subscribe((resp: any) => {
      this.profiles = this.toArray(resp).map((item: any) => ({
        id: Number(item.id),
        name: String(item.name || '')
      }));
    });

    this.usuariosService.listarSucursales(this.token).subscribe((resp: any) => {
      this.sucursales = this.toArray(resp).map((item: any) => ({
        COD_SURC: Number(item.COD_SURC),
        DIR_SURC: String(item.DIR_SURC || '')
      }));
    });

    this.usuariosService.listarUsuarios(this.token).subscribe((resp: any) => {
      this.usuarios = this.toArray(resp).map((item: any) => ({
        id: Number(item.id),
        nombre: String(item.nombre || ''),
        usuario: String(item.usuario || ''),
        perfil: String(item.perfil || ''),
        profile_id: item.profile_id != null ? Number(item.profile_id) : null,
        estado: String(item.estado ?? '0'),
        ultimo_login: item.ultimo_login || null,
        foto: item.foto || null,
        telefonousuario: item.telefonousuario || null,
        id_usuario_api: item.id_usuario_api || null,
        FK_COD_SURCUSU: item.FK_COD_SURCUSU != null ? Number(item.FK_COD_SURCUSU) : null,
        sucursal: item.sucursal || null,
        asistente: item.asistente != null ? String(item.asistente) : '0',
        personalAC: item.personalAC != null ? String(item.personalAC) : null,
        ACCESOS_APP_ASE: item.ACCESOS_APP_ASE != null ? String(item.ACCESOS_APP_ASE) : null,
        omitir_validacion_ip: item.omitir_validacion_ip != null ? String(item.omitir_validacion_ip) : '0'
      }));

      this.aplicarFiltros();
      this.cargando = false;
    });
  }

  aplicarFiltros() {
    const text = this.q.trim().toLowerCase();

    this.usuariosFiltrados = this.usuarios.filter((u) => {
      const byText = !text ||
        u.nombre.toLowerCase().includes(text) ||
        u.usuario.toLowerCase().includes(text);
      const byProfile = !this.filtroProfileId || String(u.profile_id || '') === this.filtroProfileId;
      const byEstado = !this.filtroEstado || String(u.estado) === this.filtroEstado;
      return byText && byProfile && byEstado;
    });
    this.currentPage = 1;
  }

  abrirNuevo() {
    this.modoEdicion = false;
    this.form = this.getDefaultForm();
    this.serviciosSeleccionados = [];
    this.seccionInformeAbierta = false;
    this.seccionAsesorAbierta = false;
    this.cargarServiciosInforme();
    this.modalAbierto = true;
  }

  cargarServiciosInforme(): void {
    if (this.serviciosInforme.length > 0) return;
    this.cargandoServiciosInforme = true;
    this.informesRxService.listarServiciosInforme(this.token).subscribe({
      next: (resp: any) => {
        this.cargandoServiciosInforme = false;
        this.serviciosInforme = Array.isArray(resp?.rows) ? resp.rows : [];
      },
      error: () => {
        this.cargandoServiciosInforme = false;
        this.serviciosInforme = [];
      }
    });
  }

  cargarServiciosUsuario(usuarioId: number): void {
    this.informesRxService.obtenerServiciosUsuario(usuarioId, this.token).subscribe({
      next: (resp: any) => {
        this.serviciosSeleccionados = Array.isArray(resp?.codPros) ? resp.codPros.map(Number) : [];
        this.seccionInformeAbierta = this.serviciosSeleccionados.length > 0;
      },
      error: () => {
        this.serviciosSeleccionados = [];
        this.seccionInformeAbierta = false;
      }
    });
  }

  isServicioInformeSeleccionado(codPro: number): boolean {
    return this.serviciosSeleccionados.includes(Number(codPro));
  }

  toggleServicioInforme(codPro: number): void {
    const cod = Number(codPro);
    const idx = this.serviciosSeleccionados.indexOf(cod);
    if (idx >= 0) this.serviciosSeleccionados.splice(idx, 1);
    else this.serviciosSeleccionados.push(cod);
  }

  guardarServiciosInforme(usuarioId: number): void {
    this.informesRxService.actualizarServiciosUsuario(usuarioId, this.serviciosSeleccionados, this.token)
      .subscribe({ next: () => {}, error: () => {} });
  }

  abrirEdicion(row: UsuarioRow) {
    this.modoEdicion = true;
    this.modalAbierto = true;
    this.cargandoEdicion = true;
    this.serviciosSeleccionados = [];
    this.seccionAsesorAbierta = false;
    this.seccionInformeAbierta = false;

    this.cargarServiciosInforme();
    this.cargarServiciosUsuario(row.id);

    this.form = this.getDefaultForm();
    this.form.id = row.id;

    this.usuariosService.obtenerUsuarioPorId(this.token, row.id).subscribe((resp: any) => {
      this.cargandoEdicion = false;

      if (this.hasError(resp)) {
        this.toastr.error(this.extractError(resp));
        this.modalAbierto = false;
        return;
      }

      const item = this.toArray(resp)[0];
      if (!item) {
        this.toastr.error('No se encontró el usuario a editar');
        this.modalAbierto = false;
        return;
      }

      const normalized: UsuarioRow = {
        id: Number(item.id),
        nombre: String(item.nombre || ''),
        usuario: String(item.usuario || ''),
        perfil: String(item.perfil || ''),
        profile_id: item.profile_id != null ? Number(item.profile_id) : null,
        estado: String(item.estado ?? '0'),
        ultimo_login: item.ultimo_login || null,
        foto: item.foto || null,
        telefonousuario: item.telefonousuario || null,
        id_usuario_api: item.id_usuario_api || null,
        FK_COD_SURCUSU: item.FK_COD_SURCUSU != null ? Number(item.FK_COD_SURCUSU) : null,
        sucursal: item.sucursal || null,
        asistente: item.asistente != null ? String(item.asistente) : '0',
        personalAC: item.personalAC != null ? String(item.personalAC) : null,
        ACCESOS_APP_ASE: item.ACCESOS_APP_ASE != null ? String(item.ACCESOS_APP_ASE) : null,
        omitir_validacion_ip: item.omitir_validacion_ip != null ? String(item.omitir_validacion_ip) : '0'
      };

      const selectedProfileId = this.resolveProfileIdForRow(normalized);
      this.form = {
        id: normalized.id,
        nombre: normalized.nombre,
        usuario: normalized.usuario,
        password: '',
        profile_id: selectedProfileId,
        profile_name: normalized.perfil || '',
        FK_COD_SURCUSU: normalized.FK_COD_SURCUSU ? String(normalized.FK_COD_SURCUSU) : '',
        telefonousuario: normalized.telefonousuario || '',
        asistente: String(normalized.asistente || '0'),
        personalAC: this.parsePersonalAC(normalized.personalAC),
        accesosAppAse: this.parseAccesosAppAse(normalized.ACCESOS_APP_ASE),
        omitir_validacion_ip: String(normalized.omitir_validacion_ip || '0'),
        estado: String(normalized.estado || '1')
      };

      this.seccionAsesorAbierta = this.esPerfilAsesor() && (
        this.form.accesosAppAse.some((i: MenuAppItem) => i.acceso) ||
        this.form.personalAC.length > 0
      );
    });
  }

  cerrarModal() {
    if (this.guardando) return;
    this.modalAbierto = false;
  }

  guardarUsuario() {
    if (!this.canWrite) {
      this.toastr.error('No tienes permiso para modificar usuarios');
      return;
    }

    if (!this.form.nombre || !this.form.usuario || !this.form.profile_id) {
      this.toastr.error('Nombre, usuario y perfil son obligatorios');
      return;
    }

    if (!this.modoEdicion && String(this.form.password || '').trim().length < 6) {
      this.toastr.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    const payload: any = {
      nombre: this.form.nombre,
      usuario: this.form.usuario,
      profile_id: Number(this.form.profile_id),
      FK_COD_SURCUSU: this.form.FK_COD_SURCUSU ? Number(this.form.FK_COD_SURCUSU) : null,
      telefonousuario: this.form.telefonousuario,
      foto: this.defaultUserPhoto,
      omitir_validacion_ip: this.form.omitir_validacion_ip === '1' ? '1' : '0',
      estado: this.form.estado
    };

    if (this.esPerfilAsesor()) {
      payload.asistente = this.form.asistente === '1' ? '1' : '0';
      payload.personalAC = this.form.personalAC.map((name: string) => ({ usuarioAC: name }));
      payload.ACCESOS_APP_ASE = this.form.accesosAppAse.map((item: MenuAppItem) => ({ ...item }));
    } else {
      payload.asistente = '0';
      payload.personalAC = [];
      payload.ACCESOS_APP_ASE = [];
    }

    const password = String(this.form.password || '').trim();
    if (!this.modoEdicion || password.length > 0) {
      payload.password = password;
    }

    this.guardando = true;

    const done = (resp: any, okMessage: string, usuarioId: number) => {
      if (this.hasError(resp)) {
        this.toastr.error(this.extractError(resp));
      } else {
        this.guardarServiciosInforme(usuarioId);
        this.toastr.success(okMessage);
        this.modalAbierto = false;
        this.cargarCatalogosYUsuarios();
      }
      this.guardando = false;
    };

    if (!this.modoEdicion) {
      this.usuariosService.crearUsuario(this.token, payload).subscribe((resp: any) => {
        const newId = resp?.id || resp?.insertId || 0;
        done(resp, 'Usuario creado correctamente', newId);
      });
      return;
    }

    this.usuariosService.actualizarUsuario(this.token, Number(this.form.id), payload).subscribe((resp: any) => {
      done(resp, 'Usuario actualizado correctamente', Number(this.form.id));
    });
  }

  cambiarEstado(row: UsuarioRow) {
    if (!this.canWrite) {
      this.toastr.error('No tienes permiso para modificar usuarios');
      return;
    }

    const nuevoEstado = String(row.estado) === '1' ? '0' : '1';
    this.usuariosService.actualizarEstado(this.token, row.id, nuevoEstado).subscribe((resp: any) => {
      if (this.hasError(resp)) {
        this.toastr.error(this.extractError(resp));
        return;
      }
      this.toastr.success('Estado actualizado');
      this.cargarCatalogosYUsuarios();
    });
  }

  eliminar(row: UsuarioRow) {
    if (!this.canWrite) {
      this.toastr.error('No tienes permiso para eliminar usuarios');
      return;
    }

    Swal.fire({
      title: `¿Eliminar usuario ${row.usuario}?`,
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.usuariosService.eliminarUsuario(this.token, row.id).subscribe((resp: any) => {
        if (this.hasError(resp)) {
          this.toastr.error(this.extractError(resp));
          return;
        }

        this.toastr.success('Usuario eliminado correctamente');
        this.cargarCatalogosYUsuarios();
      });
    });
  }

  formatDate(value: string | null): string {
    if (!value) return '-';
    const date = new Date(value);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleString('es-EC');
  }

  getProfileName(profileId: number | null): string {
    if (!profileId) return '-';
    const found = this.profiles.find((x) => x.id === profileId);
    return found ? found.name : '-';
  }

  isActive(row: UsuarioRow): boolean {
    return String(row.estado) === '1';
  }

  resolveFotoUrl(foto: string | null): string {
    const raw = String(foto || '').trim();
    if (!raw) return 'assets/img/faces/1.jpg';
    if (/^https?:\/\//i.test(raw)) return raw;
    if (raw.startsWith('/')) return `${this.legacyImageBaseUrl.replace(/\/$/, '')}${raw}`;
    if (raw.startsWith('vistas/')) return `${this.legacyImageBaseUrl}${raw}`;
    return raw;
  }

  onQChange(event: Event): void {
    const target = event.target as HTMLInputElement | null;
    this.q = target?.value || '';
    this.aplicarFiltros();
  }

  onFiltroProfileChange(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    this.filtroProfileId = target?.value || '';
    this.aplicarFiltros();
  }

  onFiltroEstadoChange(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    this.filtroEstado = target?.value || '';
    this.aplicarFiltros();
  }

  onPageSizeChange(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    const value = Number(target?.value || this.pageSize);
    this.pageSize = this.pageSizeOptions.includes(value) ? value : 20;
    this.currentPage = 1;
  }

  get totalPages(): number {
    const total = Math.ceil(this.usuariosFiltrados.length / this.pageSize);
    return total > 0 ? total : 1;
  }

  get startRow(): number {
    if (!this.usuariosFiltrados.length) return 0;
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get endRow(): number {
    if (!this.usuariosFiltrados.length) return 0;
    return Math.min(this.currentPage * this.pageSize, this.usuariosFiltrados.length);
  }

  get usuariosPaginados(): UsuarioRow[] {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.usuariosFiltrados.slice(start, end);
  }

  prevPage(): void {
    if (this.currentPage <= 1) return;
    this.currentPage -= 1;
  }

  nextPage(): void {
    if (this.currentPage >= this.totalPages) return;
    this.currentPage += 1;
  }

  setFormField(field: string, event: Event): void {
    const target = event.target as HTMLInputElement | HTMLSelectElement | null;
    this.form[field] = target?.value ?? '';
    if (field === 'profile_id') {
      const profile = this.profiles.find((p) => String(p.id) === String(this.form.profile_id || ''));
      this.form.profile_name = profile ? profile.name : this.form.profile_name;
      this.seccionAsesorAbierta = false;
      if (!this.esPerfilAsesor()) {
        this.form.asistente = '0';
        this.form.personalAC = [];
        this.form.accesosAppAse = MENU_APP_ASESOR_BASE.map((item) => ({ ...item, acceso: false }));
      } else if (!Array.isArray(this.form.accesosAppAse) || !this.form.accesosAppAse.length) {
        this.form.accesosAppAse = MENU_APP_ASESOR_BASE.map((item) => ({ ...item }));
      }
    }
  }

  toggleSeccionAsesor(): void {
    this.seccionAsesorAbierta = !this.seccionAsesorAbierta;
  }

  toggleSeccionInforme(): void {
    this.seccionInformeAbierta = !this.seccionInformeAbierta;
  }

  private toArray(resp: any): any[] {
    if (resp?.rows && Array.isArray(resp.rows)) {
      return resp.rows;
    }
    return [];
  }

  private hasError(resp: any): boolean {
    return !!resp?.error || !!resp?.statusCode || !!resp?.name;
  }

  private extractError(resp: any): string {
    if (resp?.rows?.[0]?.detalle) return String(resp.rows[0].detalle);
    if (resp?.error?.rows?.[0]?.detalle) return String(resp.error.rows[0].detalle);
    if (resp?.error) return String(resp.error);
    if (resp?.message) return String(resp.message);
    return 'No se pudo procesar la solicitud';
  }

  private resolveProfileIdForRow(row: UsuarioRow): string {
    if (row.profile_id) {
      return String(row.profile_id);
    }

    const perfilNombre = String(row.perfil || '').trim().toLowerCase();
    if (!perfilNombre) return '';

    const profile = this.profiles.find((p) => String(p.name || '').trim().toLowerCase() === perfilNombre);
    return profile ? String(profile.id) : '';
  }

  isProfileOptionSelected(optionId: number, optionName: string): boolean {
    const selectedId = String(this.form.profile_id || '').trim();
    if (selectedId) {
      return selectedId === String(optionId);
    }
    const selectedName = String(this.form.profile_name || '').trim().toLowerCase();
    return selectedName.length > 0 && selectedName === String(optionName || '').trim().toLowerCase();
  }

  isSucursalOptionSelected(optionId: number): boolean {
    return String(this.form.FK_COD_SURCUSU || '').trim() === String(optionId);
  }

  get asesoresDisponibles(): UsuarioRow[] {
    return this.usuarios
      .filter((u) => String(u.perfil || '').trim().toLowerCase() === 'asesor')
      .filter((u) => Number(u.id) !== Number(this.form.id || 0));
  }

  esPerfilAsesor(): boolean {
    const selectedId = String(this.form.profile_id || '').trim();
    const selectedById = this.profiles.find((p) => String(p.id) === selectedId);
    if (selectedById) {
      return String(selectedById.name || '').trim().toLowerCase() === 'asesor';
    }
    return String(this.form.profile_name || '').trim().toLowerCase() === 'asesor';
  }

  onAsistenteChange(event: Event): void {
    const target = event.target as HTMLInputElement | null;
    this.form.asistente = target?.checked ? '1' : '0';
  }

  onOmitirValidacionIpChange(event: Event): void {
    const target = event.target as HTMLInputElement | null;
    this.form.omitir_validacion_ip = target?.checked ? '1' : '0';
  }

  onPersonalACChange(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    if (!target) {
      this.form.personalAC = [];
      return;
    }
    const selected = Array.from(target.selectedOptions || []).map((opt) => String(opt.value || '').trim()).filter(Boolean);
    this.form.personalAC = [...new Set(selected)];
  }

  toggleAccesoMenu(index: number, event: Event): void {
    const target = event.target as HTMLInputElement | null;
    if (!Array.isArray(this.form.accesosAppAse)) {
      this.form.accesosAppAse = MENU_APP_ASESOR_BASE.map((item) => ({ ...item }));
    }
    const checked = !!target?.checked;
    this.form.accesosAppAse = this.form.accesosAppAse.map((item: MenuAppItem, i: number) =>
      i === index ? { ...item, acceso: checked } : item
    );
  }

  isPersonalACSelected(nombreUsuario: string): boolean {
    return this.form.personalAC.includes(String(nombreUsuario || '').trim());
  }

  private parsePersonalAC(value: string | null | undefined): string[] {
    const raw = String(value || '').trim();
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((item: any) => {
          if (item && typeof item === 'object') return String(item.usuarioAC || '').trim();
          return String(item || '').trim();
        })
        .filter((name: string) => name.length > 0);
    } catch (_) {
      return [];
    }
  }

  private parseAccesosAppAse(value: string | null | undefined): MenuAppItem[] {
    const base = MENU_APP_ASESOR_BASE.map((item) => ({ ...item }));
    const raw = String(value || '').trim();
    if (!raw) return base;

    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return base;

      const result = base.map((item) => ({ ...item }));

      const countBy = (items: MenuAppItem[], selector: (item: MenuAppItem) => string) => {
        const map = new Map<string, number>();
        items.forEach((item) => {
          const key = selector(item);
          map.set(key, (map.get(key) || 0) + 1);
        });
        return map;
      };

      const baseRutaCount = countBy(base, (item) => this.normalizeTextKey(item.ruta));
      const baseTipoCount = countBy(base, (item) => this.normalizeTextKey(item.tipo));

      const findBaseIndex = (entry: any): number => {
        const title = this.normalizeTextKey(entry?.title);
        const ruta = this.normalizeTextKey(entry?.ruta);
        const tipo = this.normalizeTextKey(entry?.tipo);

        const byRutaTipo = base.findIndex((item) =>
          this.normalizeTextKey(item.ruta) === ruta &&
          this.normalizeTextKey(item.tipo) === tipo
        );
        if (byRutaTipo >= 0) return byRutaTipo;

        if (tipo && (baseTipoCount.get(tipo) || 0) === 1) {
          const byTipo = base.findIndex((item) => this.normalizeTextKey(item.tipo) === tipo);
          if (byTipo >= 0) return byTipo;
        }

        if (title) {
          const byTitle = base.findIndex((item) => this.normalizeTextKey(item.title) === title);
          if (byTitle >= 0) return byTitle;
        }

        if (ruta && (baseRutaCount.get(ruta) || 0) === 1) {
          const byRuta = base.findIndex((item) => this.normalizeTextKey(item.ruta) === ruta);
          if (byRuta >= 0) return byRuta;
        }

        return -1;
      };

      parsed.forEach((entry: any) => {
        const idx = findBaseIndex(entry);
        if (idx < 0) return;

        const current = result[idx];
        result[idx] = {
          title: String(entry?.title || current.title),
          description: String(entry?.description || current.description),
          avatar: String(entry?.avatar || current.avatar),
          ruta: String(entry?.ruta || current.ruta),
          tipo: String(entry?.tipo || current.tipo),
          acceso: this.normalizeAccesoFlag(entry?.acceso)
        };
      });

      return result;
    } catch (_) {
      return base;
    }
  }

  private normalizeTextKey(value: any): string {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  private normalizeAccesoFlag(value: any): boolean {
    const raw = String(value ?? '').trim().toLowerCase();
    return raw === '1' || raw === 'true' || raw === 'si' || raw === 'yes';
  }
}
